import {AnyAction} from "redux";
import * as _ from "lodash";
import {SET_HIGHLIGHT_LOCATION} from "../actions/action";
import {getPowerSourceLocationsData, IPowerSourceLocation} from "../../data/data";
import {createSelector} from "reselect";

//  define selectors

export const getHighlightLocation = state => state.highlightLocation;
export const isLocationHighlighted = (state, props: {location_id: number}) => state.highlightLocation === props.location_id;


/**
 * get the data for the highlight location
 */
export const getHighlightLocationData = createSelector(

    [getHighlightLocation],

    (location_id: number) : IPowerSourceLocation =>
    {
        const locations: IPowerSourceLocation[] = getPowerSourceLocationsData();

        return locations[location_id];
    }
);


//  define the initial state

const initialState: number = null;


/**
 * reducer: set the highlight location
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function highlightLocation(state: number = initialState, action: AnyAction) : number
{
    switch (action.type)
    {
        case SET_HIGHLIGHT_LOCATION:
        {
            const {payload} = action;
            const {location_id} = payload;

            return location_id;
        }

        default:

            return state;
    }
}


// WEBPACK FOOTER //
// ./src/ts/store/reducers/highlightLocation.ts